/**
 * Returns a UI string indicating how long ago a given timestamp was
 * @param timestamp - The timestamp to calculate time ago from
 * @returns A string like "just now", "5m ago", "2h ago", or "3d ago"
 */
export const getReadableTime = (
  timestamp: Date | string | undefined,
): string => {
  if (!timestamp) return "just now";

  const now = new Date();
  const diffInMinutes = Math.floor(
    (now.getTime() - new Date(timestamp).getTime()) / (1000 * 60),
  );

  if (diffInMinutes < 1) return "just now";
  if (diffInMinutes < 60) return `${diffInMinutes}m ago`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours}h ago`;

  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays}d ago`;
};
